import React from 'react';
import { Form, Space, Input, Image } from 'antd';
import { TableData } from '../../../models/tableData/types';

interface Props {
    tableData: TableData;
    changeSearch: (value: string) => void;
    handleSearchSubmit: () => void;
}

const ProjectLibrarySearch: React.FC<Props> = ({ tableData, changeSearch, handleSearchSubmit }) => {
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        changeSearch!(e.target.value);
    };

    const clearSearchInput = () => {
        changeSearch!('');
    };

    return (
        <Form>
            <Space>
                <Input
                    placeholder="Project, ID, owner, client/owner"
                    onPressEnter={handleSearchSubmit}
                    onChange={handleSearchChange}
                    value={tableData.searchString}
                    id="table-search-input"
                    prefix={
                        <>
                            {!tableData.searchString && (
                                <Image
                                    src="src/assets/images/magnifying-glass.svg"
                                    preview={false}
                                />
                            )}
                        </>
                    }
                    suffix={
                        <>
                            {tableData.searchString && (
                                <Image
                                    preview={false}
                                    src="src/assets/images/close-circle-icon.svg"
                                    onClick={clearSearchInput}
                                />
                            )}
                        </>
                    }
                ></Input>
            </Space>
        </Form>
    );
};

export default ProjectLibrarySearch;
